import { useEffect, useState } from 'react';
import './CustomCursor.css';

type CustomCursorProps = {
  hoverTargetClass?: string;
  normalImage: string;
  hoverImage: string;
};

export const CustomCursor = ({ hoverTargetClass = 'enter-button', normalImage, hoverImage }: CustomCursorProps) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const updatePosition = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains(hoverTargetClass)) {
        setIsHovering(true);
      }
    };

    const handleMouseOut = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains(hoverTargetClass)) {
        setIsHovering(false);
      }
    };

    document.addEventListener('mousemove', updatePosition);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);

    return () => {
      document.removeEventListener('mousemove', updatePosition);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, [hoverTargetClass]);

  return (
    <img
      className={`custom-cursor ${isHovering ? 'custom-cursor--hover' : ''}`}
      src={isHovering ? hoverImage : normalImage}
      alt=""
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    />
  );
};
